import React, { FocusEventHandler, useCallback, useState } from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../../components/Icon';
import { theme } from '../../../../styles/theme';
import { AuthInputField } from '../LoginPagesUI';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  placeholder: string;
  autoComplete?: string;
  hasError?: boolean;
}

const Container = styled.div`
  position: relative;
`;
const PositionedTypeToggle = styled(SvgIcon)`
  position: absolute;
  top: 14px;
  right: 14px;
  color: ${theme.colors.secondary400};
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const AuthFormPasswordField = ({
  value,
  onChange,
  placeholder,
  autoComplete,
  hasError,
}: IProps) => {
  const [isPasswordType, setIsPasswordType] = useState(true);

  const toggleFieldType = useCallback(() => {
    setIsPasswordType((prevState) => !prevState);
  }, []);

  return (
    <Container>
      <AuthInputField
        type={isPasswordType ? 'password' : 'text'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        hasError={hasError}
      />
      <PositionedTypeToggle
        name={isPasswordType ? 'eye' : 'eye-slash'}
        width={24}
        height={24}
        onClick={toggleFieldType}
        customFill="currentColor"
      />
    </Container>
  );
};

export default AuthFormPasswordField;
